class AgendaGridFilter {
  constructor() {
    this.init();
  }

  init() {
    // Não fazer nada aqui - toda a lógica de filtro está em agenda-load-more.js
    // Este arquivo pode ser mantido para compatibilidade ou removido depois
    console.log('AgendaGridFilter inicializado (desativado - filtros gerenciados por AgendaLoadMore)');
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AgendaGridFilter();
  });
} else {
  new AgendaGridFilter();
}
